module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.30266",
      "ably": "static-2.2",
      "ably-hubspot-js": "static-2.4950",
      "atom": "static-1.5305",
      "conversations-error-reporting": "static-1.9118",
      "conversations-internal-pub-sub": "static-1.16212",
      "conversations-internal-schema": "static-1.13297",
      "conversations-message-history": "static-1.13401",
      "conversations-test-sdk": "static-1.10732",
      "conversations-visitor-experience-components": "static-1.23629",
      "data-fetching-client": "static-1.9886",
      "head-dlb": "static-1.5007",
      "hs-promise-utils": "static-1.5824",
      "hs-test-utils": "static-1.8254",
      "hubspot-dlb": "static-2.1877",
      "HubStyleTokens": "static-2.11710",
      "I18n": "static-7.1655",
      "immer": "static-1.94",
      "jasmine-immutable": "static-1.3252",
      "jasmine-runner": "static-1.6677",
      "quartz": "static-1.7339",
      "react-dlb": "static-1.84",
      "react-select-plus": "static-1.108",
      "react-transition-group": "static-2.68",
      "redux-thunk": "static-2.43",
      "reselect": "static-3.8",
      "sanitize": "static-1.4705",
      "StyleGuideUI": "static-3.492",
      "transmute": "static-2.85",
      "urlinator": "static-1.4762",
      "usage-tracker": "static-1.7586",
      "usage-tracker-core": "static-1.7436",
      "usage-tracker-public": "static-1.7397",
      "viral-links-lib": "static-1.7302",
      "visitor-ui-component-library": "static-1.6381",
      "webpack-env": "static-1.54",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.5038",
      "conversations-prop-types": "static-1.7684",
      "conversations-visitor-message-history": "static-1.22366",
      "cssUtils": "static-1.861",
      "enviro": "static-4.455",
      "flux-actions": "static-1.357",
      "foundations-components": "static-1.8355",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.6442",
      "interactive-cards": "static-1.275",
      "hubspot-url-utils": "static-1.4282",
      "immutable": "static-2.83",
      "metrics-js": "static-1.9849",
      "PatternValidationJS": "static-1.3124",
      "PortalIdParser": "static-2.404",
      "raven": "static-3.5925",
      "react": "static-7.190",
      "react-aria": "static-1.69",
      "react-dom": "static-7.85",
      "react-redux": "static-7.75",
      "react-rhumb": "static-1.16935",
      "react-utils": "static-2.5500",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "sanitize-text": "static-1.8377",
      "signup-constants": "static-1.19455",
      "styled-components": "static-2.94",
      "usage-tracker-multi": "static-1.6000",
      "visitor-ui-component-library-icons": "static-1.6192",
      "hs-promise-rejection-tracking": "static-1.5587",
      "raven-hubspot": "static-1.6232",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.3560",
      "moment": "static-3.26",
      "quartz-config": "static-1.1117",
      "quartz-core": "static-1.6558",
      "foundations-assets": "static-1.5104",
      "foundations-theming": "static-1.4681",
      "UIComponents": "static-3.8656",
      "conversations-async-data": "static-2.7898",
      "customer-data-email": "static-1.18424",
      "cv-backend-services": "static-1.1590",
      "immutable-less": "static-1.4880",
      "conversations-skeleton-state": "static-1.7478",
      "crm-events-viz-core": "static-1.33856",
      "customer-data-objects": "static-1.7913",
      "icons": "static-2.672",
      "react-input-autosize": "static-2.17",
      "react-performance-metrics-lib": "static-1.783",
      "rpc-client-utils": "static-1.4891",
      "ui-images": "static-2.1222",
      "apollo-stack-hubspot": "static-3.89",
      "fast-json-stable-stringify": "static-1.4",
      "graphql": "static-1.85",
      "HeadJS": "static-2.785",
      "framer-motion": "static-1.75",
      "hs-test-utils-bend-plugin": "static-1.3365",
      "msw": "static-1.39",
      "testing-library": "static-1.155",
      "i18n-data": "static-1.226",
      "moment-timezone": "static-5.86",
      "jasmine": "static-4.4547",
      "signup-ui-url-generator": "static-2.8287",
      "HubStyle": "static-2.12017",
      "quartz-i18n": "static-1.1014",
      "sassPrefix": "static-1.161",
      "bend-plugin-foundations-components": "static-1.4624",
      "floating-ui": "static-1.60",
      "foundations-theming-specialty": "static-1.2397",
      "hs-story-utils": "static-1.9655",
      "react-create-root-preference": "static-1.55",
      "react-virtualized": "static-2.103",
      "tanstack-table": "static-1.58",
      "trellis-assets": "static-1.2411",
      "ui-fonts": "static-1.972",
      "hs-locale-management": "static-1.240",
      "csstype": "static-1.50",
      "quartz-head": "static-1.1004",
      "quick-fetch": "static-1.4076",
      "web-vitals": "static-1.9",
      "quartz-routing": "static-1.769",
      "usage-tracker-anonymous": "static-1.6003",
      "bender-build-tools": "static-1.3347",
      "dispatcher": "static-1.140",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.863",
      "hubspotter-http": "static-1.4808",
      "mobile-manifest-mixins": "static-1.560",
      "module-federation": "static-1.29",
      "quartz-auth": "static-1.1014",
      "quartz-test": "static-1.1014",
      "quartz-tracking": "static-1.718",
      "trellis-components": "static-1.2430",
      "usage-tracker-container": "static-1.7576",
      "bend-plugin-foundations-theming": "static-1.3164",
      "foundations-theming-base": "static-1.3666",
      "stylex": "static-1.37",
      "react-immutable-proptypes": "static-2.8",
      "apollo-dlb": "static-3.86",
      "apollo-link-hub-http": "static-2.4886",
      "customer-data-ui-utilities": "static-1.10055",
      "FileManagerCore": "static-1.39811",
      "FileManagerLib": "static-1.39952",
      "hubspot-apollo-client": "static-1.5106",
      "react-immutable-render-mixin": "static-1.9",
      "salesImages": "static-1.530",
      "timezone-utils": "static-2.5475",
      "ui-gdpr-components": "static-1.10583",
      "ts-schema": "static-1.4238",
      "ai-components-ui-library": "static-1.9543",
      "avatar-components": "static-1.2726",
      "content-assistance-lib": "static-1.8106",
      "crm-component-utils": "static-1.39697",
      "crm-display-components": "static-1.25447",
      "crm-fe-perf": "static-1.23128",
      "crm-links": "static-1.6548",
      "crm-message-bus": "static-1.43593",
      "crm-search-service-types": "static-1.1383",
      "crm-source-interpretation-lib": "static-1.5562",
      "customer-data-communicator": "static-1.46180",
      "customer-data-filters-ui": "static-1.40691",
      "customer-data-objects-ui-components": "static-1.13260",
      "customer-data-properties": "static-1.52370",
      "customer-data-rte": "static-1.33528",
      "draft-plugins": "static-2.22057",
      "file-manager-components": "static-1.24312",
      "trellis-theming": "static-1.1184",
      "framework-data-schema-resolvers": "static-1.7122",
      "frontend-preferences-client": "static-1.8157",
      "hubspot-prosemirror": "static-1.18852",
      "object-comments-thread-lib": "static-1.11229",
      "prosemirror-user-and-team-at-mentions": "static-1.1083",
      "reference-resolvers-lite": "static-1.8327",
      "ui-addon-upgrades": "static-9.18300",
      "universal-associations-select": "static-1.11298",
      "universal-record-utils-lib": "static-1.1666",
      "wootric-nps": "static-1.7145",
      "inbound-db-properties-service-client": "static-1.4005",
      "property-translator": "static-1.5622",
      "segments-query-core": "static-1.1652",
      "bend-plugin-chirp-manifest": "static-1.301",
      "chirp-fetch": "static-1.2116",
      "hub-http-shared-msw-handlers": "static-1.10494",
      "hubspotter-http-shared-msw-handlers": "static-1.10492",
      "usage-tracker-session-replay": "static-1.5272",
      "base-ui": "static-1.17",
      "react-day-picker": "static-1.6",
      "tanstack-virtual": "static-1.35",
      "react-dnd-compat": "static-1.4844",
      "breeze-artifacts-sdk": "static-1.121",
      "audio-components": "static-1.6248",
      "ContentUtils": "static-1.69012",
      "cropperjs": "static-1.10",
      "feedback-loader": "static-1.29705",
      "FileManagerImages": "static-1.37463",
      "foundations-components-legacy": "static-1.1380",
      "html-to-image": "static-1.57",
      "immerable": "static-1.4380",
      "react-colorpicker": "static-2.10436",
      "ui-universal-auth": "static-1.9252",
      "video-components": "static-1.14007",
      "video-data-lib": "static-1.35663",
      "video-embed": "static-1.36497",
      "hubspot-apollo-cache": "static-1.565",
      "chatspot-core": "static-1.22537",
      "copilot-toolkit": "static-1.11707",
      "superstore": "static-1.4985",
      "ui-addon-video-player": "static-1.8935",
      "ui-coaching-tips": "static-1.29177",
      "card-properties-lib": "static-1.44864",
      "commerce-subscription-lib": "static-1.37639",
      "crm-actions": "static-1.6579",
      "crm-cards-sdk": "static-1.44329",
      "customer-data-properties-shared-msw-handlers": "static-1.9821",
      "customer-data-property-utils": "static-1.8326",
      "customer-data-tracking": "static-1.7111",
      "hs-resources": "static-1.417",
      "inbound-db-meta-service-client": "static-1.3718",
      "pulse": "static-1.853",
      "framework-data-table": "static-2.12414",
      "location-customization-utils-lib": "static-1.9952",
      "restore-request-side-panel-lib": "static-1.1493",
      "calling-error-reporting": "static-1.31552",
      "calling-internal-common": "static-1.31545",
      "calling-usage-tracker": "static-1.6768",
      "crm_data": "static-4.92698",
      "customer-data-content": "static-1.27702",
      "draft-content-plugins": "static-1.28792",
      "draft-convert": "static-2.76",
      "draft-extend": "static-3.79",
      "draft-js": "static-5.81",
      "draft-signature-plugin": "static-1.24597",
      "EmailSignatureEditor": "static-1.24881",
      "hubspot-prosemirror-plugins": "static-1.18844",
      "integration-settings-components": "static-1.16080",
      "integrations-lib": "static-1.16878",
      "integrations-tracking-lib": "static-1.5837",
      "native-integrations-shared-strings": "static-1.8006",
      "nav-meta": "static-1.30324",
      "onboarding-scopes": "static-1.6687",
      "outreach-assistant-email-generation": "static-1.6701",
      "prosemirror": "static-1.13",
      "prosemirror-copilot": "static-1.12187",
      "quotes-client-types": "static-1.38791",
      "reference-resolvers": "static-1.8411",
      "rich-text-lib": "static-1.20208",
      "sales-email-signature-service-client": "static-1.4074",
      "sequences-lib": "static-1.8422",
      "ui-addon-i18n": "static-1.11375",
      "ui-addon-iframeable": "static-1.9305",
      "ui-business-units-lib": "static-1.9310",
      "ui-shepherd-react": "static-3.10491",
      "user-context": "static-1.5341",
      "whatsapp-sending-lib": "static-1.6590",
      "customer-data-filters-ui-msw-helpers": "static-1.23126",
      "customer-data-reference-ui-components": "static-1.13407",
      "events-data-lib": "static-1.471",
      "FormUrlGenerator": "static-2.4954",
      "framework-builder-read-service-client": "static-1.4166",
      "framework-data-schema-quick-fetch": "static-1.7027",
      "multi-account-reference-resolvers": "static-1.1226",
      "onboarding-tours": "static-1.17012",
      "reporting-datasets-permissions-lib": "static-1.14332",
      "SharedI18nStrings": "static-1.182",
      "ui-addon-teams": "static-1.21835",
      "batch-promise": "static-1.1773",
      "calling-global-api": "static-1.65299",
      "calling-lifecycle-internal": "static-1.66681",
      "calling-lifecycle-messages": "static-1.58975",
      "commerce-products-lib": "static-1.10363",
      "conditional-properties-service-client": "static-1.3957",
      "crm-index-visualization-core": "static-1.4448",
      "crm-pipelines-api-client-types": "static-1.4294",
      "external-options-client-types": "static-1.4285",
      "formula-editor": "static-1.14647",
      "google-libphonenumber": "static-1.41",
      "inbounddb-objects-service-types": "static-1.4371",
      "meetings-icalendar-utils-lib": "static-1.864",
      "multi-currency-client-types": "static-1.3851",
      "object-builder-ui-client": "static-1.49476",
      "pipeline-validation-client-types": "static-1.4126",
      "property-value-citations": "static-1.2984",
      "smart-property-lib": "static-1.8138",
      "tiered-pricing": "static-1.1829",
      "topics-actions-lib": "static-1.387",
      "ui-addon-form-validation": "static-1.11215",
      "zustand": "static-1.79",
      "breeze-engine-lib": "static-1.1524",
      "video-components-external": "static-1.12005",
      "fdsr-migration-layer": "static-1.241",
      "persist-promise": "static-1.3930",
      "content-media-capture": "static-1.5244",
      "emoji-mart": "static-3.4",
      "growth-payments-core": "static-1.26033",
      "knowledge-content-types": "static-1.8614",
      "payment-link-components": "static-1.24042",
      "ui-addon-emoji-picker": "static-1.10115",
      "call-summary": "static-1.39989",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.10640",
      "laboratory-lib": "static-3.7380",
      "merchandise-lib": "static-1.273",
      "purchase-motions-components": "static-1.6261",
      "crm-object-search-query-utilities": "static-1.10080",
      "amplitude-session-replay-browser": "static-1.60",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "cms-field-types": "static-1.5043",
      "content-icons-ui": "static-1.2296",
      "underscore": "static-1.8",
      "unified-auth-core-lib": "static-1.1048",
      "social-insights-client-types": "static-1.22672",
      "outpost": "static-1.4390",
      "markdown-it": "static-1.6",
      "magpie-lib": "static-1.5709",
      "magpie-types": "static-1.5169",
      "simple-logging-lib": "static-1.3278",
      "growth-onboarding-feedback-components": "static-1.6811",
      "customer-data-sidebar": "static-2.46609",
      "enrichment-properties-lib": "static-1.17708",
      "ui-addon-draggable-compat": "static-2.4490",
      "commerce-billing-lib": "static-1.19898",
      "commerce-shared-components-lib": "static-1.19097",
      "commerce-tools-ui-lib": "static-1.10925",
      "event-emitter": "static-1.1181",
      "bend-plugin-pulse": "static-1.356",
      "fast-json-patch": "static-1.66",
      "customer-data-associations": "static-1.7560",
      "reporting-data": "static-1.68500",
      "ui-addon-draggable": "static-3.4985",
      "crm-record-cards-service-types": "static-1.3739",
      "crm_universal": "static-1.22396",
      "SalesContentIndexUI": "static-3.9545",
      "content-embed-lib": "static-1.7563",
      "data-model-builder-lib": "static-1.12983",
      "remote-ui": "static-1.69",
      "ui-components-test-utils": "static-1.5847",
      "ui-extensions-remote-renderer": "static-1.17731",
      "universal-page-editor-lib": "static-1.3239",
      "integrations-error-boundary-lib": "static-1.14293",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10594",
      "rxjs": "static-5.10",
      "unified-auth": "static-1.766",
      "messaging-types-lib": "static-1.46727",
      "ai-addon-copilot-preview": "static-1.8755",
      "copilot-plugins": "static-1.11679",
      "data-token-picker": "static-1.16790",
      "sequences-client-types-lib": "static-1.8279",
      "foundations-components-test-utils": "static-1.5838",
      "navigation-messaging": "static-1.8014",
      "getting-started-shared-tasks": "static-1.19073",
      "getting-started-shared-tasks-store": "static-1.18191",
      "onboarding-tours-utils": "static-1.1078",
      "messaging-usage-based-billing-components-lib": "static-1.1852",
      "whatsapp-management-lib": "static-1.9749",
      "growth-data-modal": "static-1.5791",
      "growth-onboarding-confetti": "static-1.3290",
      "growth-onboarding-next-action-utils": "static-1.2557",
      "navigation-components": "static-1.18687",
      "onboarding-tours-client": "static-1.5226",
      "ui-shepherd-tracker": "static-1.7872",
      "shared-worker-versioning": "static-1.11268",
      "voice-sms-access-library": "static-1.1818",
      "commerce-permissions": "static-1.1005",
      "products-iframe-lib": "static-1.8462",
      "products-ui-components-shared-msw-handlers": "static-1.10876",
      "crm-index-associations-lib": "static-1.6670",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10577",
      "sales-views-client-types": "static-1.4486",
      "bark-lib": "static-1.16734",
      "browser-prettier": "static-1.11",
      "codemirror": "static-5.98",
      "crm-properties-common-lib": "static-1.6118",
      "react-codemirror": "static-1.10869",
      "data-agent-kit": "static-1.545",
      "fsm": "static-1.3966",
      "policy-lib": "static-1.7022",
      "react-tinymce": "static-1.55837",
      "tinymce": "static-5.11",
      "tinymce-config": "static-2.54963",
      "tinymce-plugins": "static-1.58077",
      "tinymce-themes": "static-1.56933",
      "breeze-engine-chat-components": "static-1.502",
      "breeze-engine-core": "static-1.802",
      "highlight.js": "static-1.82",
      "content-media-composition-data-lib": "static-1.13048",
      "content-media-compositions": "static-2.17055",
      "idb-keyval": "static-1.47",
      "media-bridge-lib": "static-1.19310",
      "fix-webm-duration": "static-1.26",
      "notification-sounds": "static-1.4653",
      "seat-types-lib": "static-1.567",
      "ui-addon-opt": "static-4.8591",
      "commerce-tours-lib": "static-1.6507",
      "growth-onboarding-reliability": "static-1.5309",
      "sales-checkout-service-client": "static-1.3765",
      "calling-cross-tab-library": "static-1.19520",
      "calling-lifecycle-usage-tracker": "static-1.9277",
      "purchase-motions-api": "static-1.6264",
      "reactive-lib": "static-1.949",
      "card-payment-highlight-lib": "static-1.37833",
      "card-subscription-highlight-lib": "static-1.40062",
      "commerce-contract-lib": "static-1.13099",
      "invoices-highlight-card-lib": "static-1.55475",
      "orders-highlight-card-lib": "static-1.22053",
      "products-highlight-card-lib": "static-1.18646",
      "quotes-highlight-card-lib": "static-1.72701",
      "usage-based-billing-components-lib": "static-1.9929",
      "utility-belt": "static-1.2761",
      "payments-enrollment-embed-lib": "static-1.23675",
      "stripe-embedded-components": "static-1.7896",
      "growth-onboarding-empty-states": "static-1.6165",
      "InboxConnectUtils": "static-4.15420",
      "payments-post-enroll-local-storage-lib": "static-1.5336",
      "qrcode-generator": "static-1.72",
      "reporting-client-types": "static-1.2635",
      "react-flip-move": "static-1.74",
      "FireAlarmUi": "static-1.4667",
      "sales-templates-service-types-lib": "static-1.4327",
      "ui-asset-management-lib": "static-1.11318",
      "association-settings-lib": "static-1.10880",
      "collaboration-sidebar": "static-1.58565",
      "conditional-property-settings-components": "static-1.50",
      "conditional-property-settings-modal": "static-1.12961",
      "data-model-commons-lib": "static-1.13248",
      "ExportDialog": "static-6.10609",
      "final-form": "static-1.73",
      "nudge-client-utils": "static-1.3039",
      "object-definition-builder-lib": "static-1.7336",
      "property-management-iframe": "static-1.13920",
      "property-usages-lib": "static-1.5710",
      "reactflow": "static-1.67",
      "simple-data-table": "static-1.3405",
      "used-in-list-lib": "static-1.7191",
      "visual-association": "static-1.6121",
      "highcharts": "static-8.107",
      "reporting-visualizations": "static-1.60576",
      "ui-extensibility-client-types": "static-1.4149",
      "adobe-sign-auth-lib": "static-1.314",
      "ads-unified-auth-lib": "static-1.891",
      "google-sheets-integration-lib": "static-1.892",
      "microsoft-drive-integration-lib": "static-1.1027",
      "surveymonkey-integration-lib": "static-1.337",
      "slack-ui-library": "static-1.10624",
      "automation-platform-service-types": "static-1.2648",
      "ContentData": "static-1.69087",
      "email-portal-health-service-types": "static-1.1207",
      "marketing-email-service-types": "static-1.2060",
      "ai-rendering-library": "static-1.10960",
      "ai-settings-ui-library": "static-1.8228",
      "ui-brand-identity-lib": "static-1.16153",
      "messaging-shared-utils-lib": "static-1.1301",
      "messaging-user-info-utils-lib": "static-1.1471",
      "content-whatsapp-service-types": "static-1.527",
      "marketing-platform-lib": "static-1.7097",
      "short-messages-app-service-client": "static-1.4149",
      "ui-tool-access": "static-1.10382",
      "onboarding-data-sync-lib": "static-1.2361",
      "growth-onboarding-next-action-components": "static-1.2585",
      "user-context-client": "static-1.4754",
      "nest": "static-1.466",
      "calling-orchestration-schema": "static-1.36595",
      "diff-match-patch": "static-1.7",
      "react-reducer-toolkit": "static-1.16231",
      "browser-eslint": "static-2.57",
      "trellis-story-utils": "static-1.4739",
      "storybook-react": "static-1.36",
      "hub-http-contrib": "static-1.3268",
      "interframe": "static-3.4984",
      "tinymce-data": "static-1.41048",
      "ui-addon-sales-email": "static-1.5442",
      "layout-dnd-components": "static-1.12863",
      "layout-dnd-utils": "static-1.11838",
      "NamespacedHubStyle": "static-2.9209",
      "js-cookie": "static-1.18",
      "products-ui-components": "static-1.40881",
      "accounting-integrations-ui-components": "static-1.7438",
      "invoices-ui-lib": "static-1.55491",
      "commerce-products-api": "static-1.2617",
      "invoices-iframe-lib": "static-1.57549",
      "quotes-modal-lib": "static-1.103379",
      "quotes-ui-lib": "static-1.81422",
      "one-click-checkout": "static-1.305",
      "platform-infra-nav-components": "static-1.7830",
      "reporting-ui-components": "static-2.65771",
      "subscription-experience-data-types": "static-1.15174",
      "marketplace-ui-apps-core": "static-1.19054",
      "stripe-connect-js": "static-1.74",
      "ui-addon-react-router-dom": "static-1.9762",
      "nested-table": "static-1.463",
      "chatspot-widget-iframe": "static-1.22528",
      "collaboration-sidebar-common": "static-1.3362",
      "conditional-property-settings-data": "static-1.68",
      "nudge-custom-function-registry": "static-1.2796",
      "nudge-renderer-utils": "static-1.3115",
      "whisper-core-api": "static-1.7186",
      "property-management-common": "static-1.6208",
      "d3": "static-1.7",
      "advanced-menus-core": "static-1.15488",
      "advanced-menus-lib": "static-1.12373",
      "ui-memberships-settings-lib": "static-1.34672",
      "breeze-onboarding-components": "static-1.578",
      "embedded-academy-lib": "static-1.15288",
      "mermaid": "static-1.3",
      "reporting-action-components": "static-1.41874",
      "reporting-snowflake": "static-1.57118",
      "upgrade-components-lib": "static-1.434",
      "meetings-connect-utils-lib": "static-1.7836",
      "layout-data-lib": "static-1.10163",
      "commerce-tax-lib": "static-1.770",
      "price-books-api": "static-1.1581",
      "price-books-components": "static-1.1639",
      "property-description-translator": "static-1.4066",
      "ramp-editor": "static-1.763",
      "commerce-analytics-service-client": "static-1.3753",
      "totals-ui-components": "static-1.24173",
      "checkout-sdk": "static-3.24243",
      "payment-method-components": "static-1.7076",
      "touchless-buying-components": "static-1.6111",
      "upgrade-catalog-service-types": "static-1.3714",
      "reporting-plugins": "static-1.10671",
      "reporting-reports": "static-1.68178",
      "edison-service-client-types": "static-1.618",
      "developer-experience-shared-components": "static-1.10727",
      "marketplace-ui-client-types": "static-1.17929",
      "marketplace-ui-common": "static-1.20522",
      "ui-addon-integrations-directory-panel": "static-2.8254",
      "react-window": "static-1.13",
      "ts-utils-lib": "static-1.404",
      "seamless-immutable": "static-7.6",
      "simple-menus-core": "static-1.15487",
      "simple-menus-lib": "static-1.17004",
      "onboarding-journeys-lib": "static-1.745",
      "academy-common-lib": "static-1.14748",
      "dashboard-lib": "static-1.82500",
      "share-with-third-party-component-lib": "static-1.8933",
      "line-items-api": "static-1.1014",
      "commerce-totals-service-types": "static-1.3976",
      "hub-http-rxjs": "static-1.828",
      "normalizr": "static-3.9",
      "ramda": "static-1.7",
      "billing-payments-client-types": "static-1.4220",
      "company-details-components": "static-1.6430",
      "emoji-regex": "static-1.7",
      "pricing-pages-ui-components": "static-1.15371",
      "quote-checkout-service-types": "static-1.3684",
      "campaign-roi-lib": "static-1.9946",
      "ui-addon-calendars": "static-2.5555",
      "apps-service-types": "static-1.3995",
      "oauth-service-types": "static-1.4483",
      "ui-product-approvals-common": "static-1.850",
      "academy-service-client": "static-1.3919",
      "croppie": "static-2.10",
      "SafeStorage": "static-1.4632",
      "trellis-ecosystem": "static-1.7530",
      "redux-actions": "static-3.7",
      "company-details-service-types": "static-1.4168",
      "pricing-pages-api": "static-1.15236"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.30266",
      "ably": "/ably/static-2.2",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.4950",
      "atom": "/atom/static-1.5305",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.9118",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.16212",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.13297",
      "conversations-message-history": "/conversations-message-history/static-1.13401",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.10732",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.23629",
      "data-fetching-client": "/data-fetching-client/static-1.9886",
      "head-dlb": "/head-dlb/static-1.5007",
      "hs-promise-utils": "/hs-promise-utils/static-1.5824",
      "hs-test-utils": "/hs-test-utils/static-1.8254",
      "hubspot-dlb": "/hubspot-dlb/static-2.1877",
      "HubStyleTokens": "/HubStyleTokens/static-2.11710",
      "I18n": "/I18n/static-7.1655",
      "immer": "/immer/static-1.94",
      "jasmine-immutable": "/jasmine-immutable/static-1.3252",
      "jasmine-runner": "/jasmine-runner/static-1.6677",
      "quartz": "/quartz/static-1.7339",
      "react-dlb": "/react-dlb/static-1.84",
      "react-select-plus": "/react-select-plus/static-1.108",
      "react-transition-group": "/react-transition-group/static-2.68",
      "redux-thunk": "/redux-thunk/static-2.43",
      "reselect": "/reselect/static-3.8",
      "sanitize": "/sanitize/static-1.4705",
      "StyleGuideUI": "/StyleGuideUI/static-3.492",
      "transmute": "/transmute/static-2.85",
      "urlinator": "/urlinator/static-1.4762",
      "usage-tracker": "/usage-tracker/static-1.7586",
      "usage-tracker-core": "/usage-tracker-core/static-1.7436",
      "usage-tracker-public": "/usage-tracker-public/static-1.7397",
      "viral-links-lib": "/viral-links-lib/static-1.7302",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.6381",
      "webpack-env": "/webpack-env/static-1.54",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.5038",
      "conversations-prop-types": "/conversations-prop-types/static-1.7684",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.22366",
      "cssUtils": "/cssUtils/static-1.861",
      "enviro": "/enviro/static-4.455",
      "flux-actions": "/flux-actions/static-1.357",
      "foundations-components": "/foundations-components/static-1.8355",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.6442",
      "interactive-cards": "/interactive-cards/static-1.275",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
      "immutable": "/immutable/static-2.83",
      "metrics-js": "/metrics-js/static-1.9849",
      "PatternValidationJS": "/PatternValidationJS/static-1.3124",
      "PortalIdParser": "/PortalIdParser/static-2.404",
      "raven": "/raven/static-3.5925",
      "react": "/react/static-7.190",
      "react-aria": "/react-aria/static-1.69",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.75",
      "react-rhumb": "/react-rhumb/static-1.16935",
      "react-utils": "/react-utils/static-2.5500",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "sanitize-text": "/sanitize-text/static-1.8377",
      "signup-constants": "/signup-constants/static-1.19455",
      "styled-components": "/styled-components/static-2.94",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.6000",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.6192",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
      "raven-hubspot": "/raven-hubspot/static-1.6232",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3560",
      "moment": "/moment/static-3.26",
      "quartz-config": "/quartz-config/static-1.1117",
      "quartz-core": "/quartz-core/static-1.6558",
      "foundations-assets": "/foundations-assets/static-1.5104",
      "foundations-theming": "/foundations-theming/static-1.4681",
      "UIComponents": "/UIComponents/static-3.8656",
      "conversations-async-data": "/conversations-async-data/static-2.7898",
      "customer-data-email": "/customer-data-email/static-1.18424",
      "cv-backend-services": "/cv-backend-services/static-1.1590",
      "immutable-less": "/immutable-less/static-1.4880",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7478",
      "crm-events-viz-core": "/crm-events-viz-core/static-1.33856",
      "customer-data-objects": "/customer-data-objects/static-1.7913",
      "icons": "/icons/static-2.672",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.783",
      "rpc-client-utils": "/rpc-client-utils/static-1.4891",
      "ui-images": "/ui-images/static-2.1222",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.89",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "graphql": "/graphql/static-1.85",
      "HeadJS": "/HeadJS/static-2.785",
      "framer-motion": "/framer-motion/static-1.75",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3365",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.155",
      "i18n-data": "/i18n-data/static-1.226",
      "moment-timezone": "/moment-timezone/static-5.86",
      "jasmine": "/jasmine/static-4.4547",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8287",
      "HubStyle": "/HubStyle/static-2.12017",
      "quartz-i18n": "/quartz-i18n/static-1.1014",
      "sassPrefix": "/sassPrefix/static-1.161",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4624",
      "floating-ui": "/floating-ui/static-1.60",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2397",
      "hs-story-utils": "/hs-story-utils/static-1.9655",
      "react-create-root-preference": "/react-create-root-preference/static-1.55",
      "react-virtualized": "/react-virtualized/static-2.103",
      "tanstack-table": "/tanstack-table/static-1.58",
      "trellis-assets": "/trellis-assets/static-1.2411",
      "ui-fonts": "/ui-fonts/static-1.972",
      "hs-locale-management": "/hs-locale-management/static-1.240",
      "csstype": "/csstype/static-1.50",
      "quartz-head": "/quartz-head/static-1.1004",
      "quick-fetch": "/quick-fetch/static-1.4076",
      "web-vitals": "/web-vitals/static-1.9",
      "quartz-routing": "/quartz-routing/static-1.769",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6003",
      "bender-build-tools": "/bender-build-tools/static-1.3347",
      "dispatcher": "/dispatcher/static-1.140",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.863",
      "hubspotter-http": "/hubspotter-http/static-1.4808",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.560",
      "module-federation": "/module-federation/static-1.29",
      "quartz-auth": "/quartz-auth/static-1.1014",
      "quartz-test": "/quartz-test/static-1.1014",
      "quartz-tracking": "/quartz-tracking/static-1.718",
      "trellis-components": "/trellis-components/static-1.2430",
      "usage-tracker-container": "/usage-tracker-container/static-1.7576",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3164",
      "foundations-theming-base": "/foundations-theming-base/static-1.3666",
      "stylex": "/stylex/static-1.37",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "apollo-dlb": "/apollo-dlb/static-3.86",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4886",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10055",
      "FileManagerCore": "/FileManagerCore/static-1.39811",
      "FileManagerLib": "/FileManagerLib/static-1.39952",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5106",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "salesImages": "/salesImages/static-1.530",
      "timezone-utils": "/timezone-utils/static-2.5475",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10583",
      "ts-schema": "/ts-schema/static-1.4238",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.9543",
      "avatar-components": "/avatar-components/static-1.2726",
      "content-assistance-lib": "/content-assistance-lib/static-1.8106",
      "crm-component-utils": "/crm-component-utils/static-1.39697",
      "crm-display-components": "/crm-display-components/static-1.25447",
      "crm-fe-perf": "/crm-fe-perf/static-1.23128",
      "crm-links": "/crm-links/static-1.6548",
      "crm-message-bus": "/crm-message-bus/static-1.43593",
      "crm-search-service-types": "/crm-search-service-types/static-1.1383",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5562",
      "customer-data-communicator": "/customer-data-communicator/static-1.46180",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.40691",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13260",
      "customer-data-properties": "/customer-data-properties/static-1.52370",
      "customer-data-rte": "/customer-data-rte/static-1.33528",
      "draft-plugins": "/draft-plugins/static-2.22057",
      "file-manager-components": "/file-manager-components/static-1.24312",
      "trellis-theming": "/trellis-theming/static-1.1184",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7122",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.8157",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18852",
      "object-comments-thread-lib": "/object-comments-thread-lib/static-1.11229",
      "prosemirror-user-and-team-at-mentions": "/prosemirror-user-and-team-at-mentions/static-1.1083",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8327",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18300",
      "universal-associations-select": "/universal-associations-select/static-1.11298",
      "universal-record-utils-lib": "/universal-record-utils-lib/static-1.1666",
      "wootric-nps": "/wootric-nps/static-1.7145",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4005",
      "property-translator": "/property-translator/static-1.5622",
      "segments-query-core": "/segments-query-core/static-1.1652",
      "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.301",
      "chirp-fetch": "/chirp-fetch/static-1.2116",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10494",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10492",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5272",
      "base-ui": "/base-ui/static-1.17",
      "react-day-picker": "/react-day-picker/static-1.6",
      "tanstack-virtual": "/tanstack-virtual/static-1.35",
      "react-dnd-compat": "/react-dnd-compat/static-1.4844",
      "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.121",
      "audio-components": "/audio-components/static-1.6248",
      "ContentUtils": "/ContentUtils/static-1.69012",
      "cropperjs": "/cropperjs/static-1.10",
      "feedback-loader": "/feedback-loader/static-1.29705",
      "FileManagerImages": "/FileManagerImages/static-1.37463",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.1380",
      "html-to-image": "/html-to-image/static-1.57",
      "immerable": "/immerable/static-1.4380",
      "react-colorpicker": "/react-colorpicker/static-2.10436",
      "ui-universal-auth": "/ui-universal-auth/static-1.9252",
      "video-components": "/video-components/static-1.14007",
      "video-data-lib": "/video-data-lib/static-1.35663",
      "video-embed": "/video-embed/static-1.36497",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.565",
      "chatspot-core": "/chatspot-core/static-1.22537",
      "copilot-toolkit": "/copilot-toolkit/static-1.11707",
      "superstore": "/superstore/static-1.4985",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8935",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.29177",
      "card-properties-lib": "/card-properties-lib/static-1.44864",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37639",
      "crm-actions": "/crm-actions/static-1.6579",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.44329",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9821",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.8326",
      "customer-data-tracking": "/customer-data-tracking/static-1.7111",
      "hs-resources": "/hs-resources/static-1.417",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
      "pulse": "/pulse/static-1.853",
      "framework-data-table": "/framework-data-table/static-2.12414",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9952",
      "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1493",
      "calling-error-reporting": "/calling-error-reporting/static-1.31552",
      "calling-internal-common": "/calling-internal-common/static-1.31545",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.6768",
      "crm_data": "/crm_data/static-4.92698",
      "customer-data-content": "/customer-data-content/static-1.27702",
      "draft-content-plugins": "/draft-content-plugins/static-1.28792",
      "draft-convert": "/draft-convert/static-2.76",
      "draft-extend": "/draft-extend/static-3.79",
      "draft-js": "/draft-js/static-5.81",
      "draft-signature-plugin": "/draft-signature-plugin/static-1.24597",
      "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24881",
      "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18844",
      "integration-settings-components": "/integration-settings-components/static-1.16080",
      "integrations-lib": "/integrations-lib/static-1.16878",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5837",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8006",
      "nav-meta": "/nav-meta/static-1.30324",
      "onboarding-scopes": "/onboarding-scopes/static-1.6687",
      "outreach-assistant-email-generation": "/outreach-assistant-email-generation/static-1.6701",
      "prosemirror": "/prosemirror/static-1.13",
      "prosemirror-copilot": "/prosemirror-copilot/static-1.12187",
      "quotes-client-types": "/quotes-client-types/static-1.38791",
      "reference-resolvers": "/reference-resolvers/static-1.8411",
      "rich-text-lib": "/rich-text-lib/static-1.20208",
      "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4074",
      "sequences-lib": "/sequences-lib/static-1.8422",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.11375",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9305",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.9310",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.10491",
      "user-context": "/user-context/static-1.5341",
      "whatsapp-sending-lib": "/whatsapp-sending-lib/static-1.6590",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23126",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13407",
      "events-data-lib": "/events-data-lib/static-1.471",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4954",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4166",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7027",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1226",
      "onboarding-tours": "/onboarding-tours/static-1.17012",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14332",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
      "ui-addon-teams": "/ui-addon-teams/static-1.21835",
      "batch-promise": "/batch-promise/static-1.1773",
      "calling-global-api": "/calling-global-api/static-1.65299",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66681",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58975",
      "commerce-products-lib": "/commerce-products-lib/static-1.10363",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3957",
      "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4448",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4294",
      "external-options-client-types": "/external-options-client-types/static-1.4285",
      "formula-editor": "/formula-editor/static-1.14647",
      "google-libphonenumber": "/google-libphonenumber/static-1.41",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4371",
      "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.864",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3851",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.49476",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4126",
      "property-value-citations": "/property-value-citations/static-1.2984",
      "smart-property-lib": "/smart-property-lib/static-1.8138",
      "tiered-pricing": "/tiered-pricing/static-1.1829",
      "topics-actions-lib": "/topics-actions-lib/static-1.387",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11215",
      "zustand": "/zustand/static-1.79",
      "breeze-engine-lib": "/breeze-engine-lib/static-1.1524",
      "video-components-external": "/video-components-external/static-1.12005",
      "fdsr-migration-layer": "/fdsr-migration-layer/static-1.241",
      "persist-promise": "/persist-promise/static-1.3930",
      "content-media-capture": "/content-media-capture/static-1.5244",
      "emoji-mart": "/emoji-mart/static-3.4",
      "growth-payments-core": "/growth-payments-core/static-1.26033",
      "knowledge-content-types": "/knowledge-content-types/static-1.8614",
      "payment-link-components": "/payment-link-components/static-1.24042",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10115",
      "call-summary": "/call-summary/static-1.39989",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10640",
      "laboratory-lib": "/laboratory-lib/static-3.7380",
      "merchandise-lib": "/merchandise-lib/static-1.273",
      "purchase-motions-components": "/purchase-motions-components/static-1.6261",
      "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10080",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "cms-field-types": "/cms-field-types/static-1.5043",
      "content-icons-ui": "/content-icons-ui/static-1.2296",
      "underscore": "/underscore/static-1.8",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1048",
      "social-insights-client-types": "/social-insights-client-types/static-1.22672",
      "outpost": "/outpost/static-1.4390",
      "markdown-it": "/markdown-it/static-1.6",
      "magpie-lib": "/magpie-lib/static-1.5709",
      "magpie-types": "/magpie-types/static-1.5169",
      "simple-logging-lib": "/simple-logging-lib/static-1.3278",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6811",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.46609",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.17708",
      "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4490",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.19898",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19097",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10925",
      "event-emitter": "/event-emitter/static-1.1181",
      "bend-plugin-pulse": "/bend-plugin-pulse/static-1.356",
      "fast-json-patch": "/fast-json-patch/static-1.66",
      "customer-data-associations": "/customer-data-associations/static-1.7560",
      "reporting-data": "/reporting-data/static-1.68500",
      "ui-addon-draggable": "/ui-addon-draggable/static-3.4985",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3739",
      "crm_universal": "/crm_universal/static-1.22396",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9545",
      "content-embed-lib": "/content-embed-lib/static-1.7563",
      "data-model-builder-lib": "/data-model-builder-lib/static-1.12983",
      "remote-ui": "/remote-ui/static-1.69",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5847",
      "ui-extensions-remote-renderer": "/ui-extensions-remote-renderer/static-1.17731",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3239",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14293",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10594",
      "rxjs": "/rxjs/static-5.10",
      "unified-auth": "/unified-auth/static-1.766",
      "messaging-types-lib": "/messaging-types-lib/static-1.46727",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.8755",
      "copilot-plugins": "/copilot-plugins/static-1.11679",
      "data-token-picker": "/data-token-picker/static-1.16790",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8279",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5838",
      "navigation-messaging": "/navigation-messaging/static-1.8014",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19073",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18191",
      "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1078",
      "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1852",
      "whatsapp-management-lib": "/whatsapp-management-lib/static-1.9749",
      "growth-data-modal": "/growth-data-modal/static-1.5791",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3290",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2557",
      "navigation-components": "/navigation-components/static-1.18687",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.5226",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7872",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.11268",
      "voice-sms-access-library": "/voice-sms-access-library/static-1.1818",
      "commerce-permissions": "/commerce-permissions/static-1.1005",
      "products-iframe-lib": "/products-iframe-lib/static-1.8462",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10876",
      "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6670",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10577",
      "sales-views-client-types": "/sales-views-client-types/static-1.4486",
      "bark-lib": "/bark-lib/static-1.16734",
      "browser-prettier": "/browser-prettier/static-1.11",
      "codemirror": "/codemirror/static-5.98",
      "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6118",
      "react-codemirror": "/react-codemirror/static-1.10869",
      "data-agent-kit": "/data-agent-kit/static-1.545",
      "fsm": "/fsm/static-1.3966",
      "policy-lib": "/policy-lib/static-1.7022",
      "react-tinymce": "/react-tinymce/static-1.55837",
      "tinymce": "/tinymce/static-5.11",
      "tinymce-config": "/tinymce-config/static-2.54963",
      "tinymce-plugins": "/tinymce-plugins/static-1.58077",
      "tinymce-themes": "/tinymce-themes/static-1.56933",
      "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.502",
      "breeze-engine-core": "/breeze-engine-core/static-1.802",
      "highlight.js": "/highlight.js/static-1.82",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13048",
      "content-media-compositions": "/content-media-compositions/static-2.17055",
      "idb-keyval": "/idb-keyval/static-1.47",
      "media-bridge-lib": "/media-bridge-lib/static-1.19310",
      "fix-webm-duration": "/fix-webm-duration/static-1.26",
      "notification-sounds": "/notification-sounds/static-1.4653",
      "seat-types-lib": "/seat-types-lib/static-1.567",
      "ui-addon-opt": "/ui-addon-opt/static-4.8591",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.6507",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5309",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3765",
      "calling-cross-tab-library": "/calling-cross-tab-library/static-1.19520",
      "calling-lifecycle-usage-tracker": "/calling-lifecycle-usage-tracker/static-1.9277",
      "purchase-motions-api": "/purchase-motions-api/static-1.6264",
      "reactive-lib": "/reactive-lib/static-1.949",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37833",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.40062",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.13099",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.55475",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.22053",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.18646",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72701",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.9929",
      "utility-belt": "/utility-belt/static-1.2761",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.23675",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.7896",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6165",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.15420",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5336",
      "qrcode-generator": "/qrcode-generator/static-1.72",
      "reporting-client-types": "/reporting-client-types/static-1.2635",
      "react-flip-move": "/react-flip-move/static-1.74",
      "FireAlarmUi": "/FireAlarmUi/static-1.4667",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4327",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11318",
      "association-settings-lib": "/association-settings-lib/static-1.10880",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.58565",
      "conditional-property-settings-components": "/conditional-property-settings-components/static-1.50",
      "conditional-property-settings-modal": "/conditional-property-settings-modal/static-1.12961",
      "data-model-commons-lib": "/data-model-commons-lib/static-1.13248",
      "ExportDialog": "/ExportDialog/static-6.10609",
      "final-form": "/final-form/static-1.73",
      "nudge-client-utils": "/nudge-client-utils/static-1.3039",
      "object-definition-builder-lib": "/object-definition-builder-lib/static-1.7336",
      "property-management-iframe": "/property-management-iframe/static-1.13920",
      "property-usages-lib": "/property-usages-lib/static-1.5710",
      "reactflow": "/reactflow/static-1.67",
      "simple-data-table": "/simple-data-table/static-1.3405",
      "used-in-list-lib": "/used-in-list-lib/static-1.7191",
      "visual-association": "/visual-association/static-1.6121",
      "highcharts": "/highcharts/static-8.107",
      "reporting-visualizations": "/reporting-visualizations/static-1.60576",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4149",
      "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.314",
      "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.891",
      "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.892",
      "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1027",
      "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.337",
      "slack-ui-library": "/slack-ui-library/static-1.10624",
      "automation-platform-service-types": "/automation-platform-service-types/static-1.2648",
      "ContentData": "/ContentData/static-1.69087",
      "email-portal-health-service-types": "/email-portal-health-service-types/static-1.1207",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.2060",
      "ai-rendering-library": "/ai-rendering-library/static-1.10960",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8228",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16153",
      "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.1301",
      "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.1471",
      "content-whatsapp-service-types": "/content-whatsapp-service-types/static-1.527",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.7097",
      "short-messages-app-service-client": "/short-messages-app-service-client/static-1.4149",
      "ui-tool-access": "/ui-tool-access/static-1.10382",
      "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2361",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2585",
      "user-context-client": "/user-context-client/static-1.4754",
      "nest": "/nest/static-1.466",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36595",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16231",
      "browser-eslint": "/browser-eslint/static-2.57",
      "trellis-story-utils": "/trellis-story-utils/static-1.4739",
      "storybook-react": "/storybook-react/static-1.36",
      "hub-http-contrib": "/hub-http-contrib/static-1.3268",
      "interframe": "/interframe/static-3.4984",
      "tinymce-data": "/tinymce-data/static-1.41048",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5442",
      "layout-dnd-components": "/layout-dnd-components/static-1.12863",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.11838",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9209",
      "js-cookie": "/js-cookie/static-1.18",
      "products-ui-components": "/products-ui-components/static-1.40881",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7438",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.55491",
      "commerce-products-api": "/commerce-products-api/static-1.2617",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.57549",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.103379",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.81422",
      "one-click-checkout": "/one-click-checkout/static-1.305",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7830",
      "reporting-ui-components": "/reporting-ui-components/static-2.65771",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15174",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19054",
      "stripe-connect-js": "/stripe-connect-js/static-1.74",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9762",
      "nested-table": "/nested-table/static-1.463",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.22528",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3362",
      "conditional-property-settings-data": "/conditional-property-settings-data/static-1.68",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2796",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3115",
      "whisper-core-api": "/whisper-core-api/static-1.7186",
      "property-management-common": "/property-management-common/static-1.6208",
      "d3": "/d3/static-1.7",
      "advanced-menus-core": "/advanced-menus-core/static-1.15488",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.12373",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34672",
      "breeze-onboarding-components": "/breeze-onboarding-components/static-1.578",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.15288",
      "mermaid": "/mermaid/static-1.3",
      "reporting-action-components": "/reporting-action-components/static-1.41874",
      "reporting-snowflake": "/reporting-snowflake/static-1.57118",
      "upgrade-components-lib": "/upgrade-components-lib/static-1.434",
      "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7836",
      "layout-data-lib": "/layout-data-lib/static-1.10163",
      "commerce-tax-lib": "/commerce-tax-lib/static-1.770",
      "price-books-api": "/price-books-api/static-1.1581",
      "price-books-components": "/price-books-components/static-1.1639",
      "property-description-translator": "/property-description-translator/static-1.4066",
      "ramp-editor": "/ramp-editor/static-1.763",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3753",
      "totals-ui-components": "/totals-ui-components/static-1.24173",
      "checkout-sdk": "/checkout-sdk/static-3.24243",
      "payment-method-components": "/payment-method-components/static-1.7076",
      "touchless-buying-components": "/touchless-buying-components/static-1.6111",
      "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3714",
      "reporting-plugins": "/reporting-plugins/static-1.10671",
      "reporting-reports": "/reporting-reports/static-1.68178",
      "edison-service-client-types": "/edison-service-client-types/static-1.618",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10727",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17929",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.20522",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8254",
      "react-window": "/react-window/static-1.13",
      "ts-utils-lib": "/ts-utils-lib/static-1.404",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "simple-menus-core": "/simple-menus-core/static-1.15487",
      "simple-menus-lib": "/simple-menus-lib/static-1.17004",
      "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.745",
      "academy-common-lib": "/academy-common-lib/static-1.14748",
      "dashboard-lib": "/dashboard-lib/static-1.82500",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8933",
      "line-items-api": "/line-items-api/static-1.1014",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3976",
      "hub-http-rxjs": "/hub-http-rxjs/static-1.828",
      "normalizr": "/normalizr/static-3.9",
      "ramda": "/ramda/static-1.7",
      "billing-payments-client-types": "/billing-payments-client-types/static-1.4220",
      "company-details-components": "/company-details-components/static-1.6430",
      "emoji-regex": "/emoji-regex/static-1.7",
      "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.15371",
      "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3684",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.9946",
      "ui-addon-calendars": "/ui-addon-calendars/static-2.5555",
      "apps-service-types": "/apps-service-types/static-1.3995",
      "oauth-service-types": "/oauth-service-types/static-1.4483",
      "ui-product-approvals-common": "/ui-product-approvals-common/static-1.850",
      "academy-service-client": "/academy-service-client/static-1.3919",
      "croppie": "/croppie/static-2.10",
      "SafeStorage": "/SafeStorage/static-1.4632",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.7530",
      "redux-actions": "/redux-actions/static-3.7",
      "company-details-service-types": "/company-details-service-types/static-1.4168",
      "pricing-pages-api": "/pricing-pages-api/static-1.15236"
    },
    "bundlingPackage": "conversations-visitor-ui",
    "bundlingPackageVersion": "static-1.30266",
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};